var Model = require('../../libs/Model');

var UserModel = Object.assign({}, require('../../../../../models/users/user'), Model);
var UserAdminModel = Object.assign({}, require('../../../../../models/users/userAdmin'), Model);

var UserForm = Object.assign({}, UserModel, Model);

UserForm.fields = Object.assign({}, UserForm.fields, UserAdminModel.fields);
delete UserForm.fields.username;
delete UserForm.fields.useUsaUnits;

module.exports = UserForm;
